module.exports = __webpack_public_path__ + "static/img/demo-texting.6ecd6d71.png";